import React from 'react'

const Image = ({ src, alt }) => (
  <img alt={alt} src={require(`../img/${src}`)} />
)

export default Image
